<div class="container-fluid d-flex flex-column justify-content-center align-items-center">
    <img src="assets/chapps-logo.png"/>
    <mdb-card id="two-factor-card" class="m-3">
        <mdb-card-body>
            <h5 appTitle class="text-center mb-4" [translate]="Localization.TwoFactorTitle"></h5>
            <p>{{ Localization.TwoFactorExplanation | translate }}</p>
            <ng-otp-input [config]="otpFieldConfig"
                          [formCtrl]="otpField"></ng-otp-input>
            <div  class="alert alert-danger mt-3"
                  role="alert"
                  *ngIf="error">
                {{ error | translate}}
            </div>
        </mdb-card-body>
        <mdb-card-footer class="text-center">
            <button *ngIf="!isBusy"
                    data-cy="backButton"
                    class="px-md-0 btn btn-link"
                    (click)="goBack()"
                    [translate]="Localization.Back">
            </button>
            <mdb-spinner *ngIf="isBusy"></mdb-spinner>
        </mdb-card-footer>
    </mdb-card>
</div>

